// 随机项配置
export const shuffleMap = {
  no: -1,
  all: 0,
  last_1: 1,
  last_2: 2,
  last_3: 3,
};

// 题型组件配置
export const questionTypeMap = {
  1: 'singleChoose',
  2: 'multipleChoose',
  3: 'cloze',
  4: 'messageCollect',
  5: 'matrixSingle',
  6: 'matrixProgress',
  7: 'NPS',
};

// 题型答案结构配置
export const answerTypeMap = {
  singleChoose: 'common',
  multipleChoose: 'common',
  cloze: 'cloze',
  messageCollect: 'messageCollect',
  matrixProgress: 'common',
  matrixSingle: 'common',
  NPS: 'common',
};

// 按钮样式
export const buttonTypeMap = {
  1: 'finger',
  2: 'number',
};

// 提交问卷答案推送字段
export const commitTypeMap = {
  common: 'answerChoose',
  cloze: 'answerSingleEdit',
  messageCollect: 'answerCollectInfo',
};

// 发奖类型 0奖励ID, 1序号, 2不发奖
export const sendTypeMap = {
  0: 'award',
  1: 'series',
  2: 'common',
};

// 支持选项跳题的题型
export const answerJumpType = ['singleChoose', 'NPS'];

// 有按钮样式区分的题型
export const hasButtonType = ['matrixProgress', 'NPS'];
